// extracted by mini-css-extract-plugin
module.exports = {"intro":"Billing_style_intro__2WoP_","row":"Billing_style_row__1hv0q","tooltip_label":"Billing_style_tooltip_label__3tucv","tooltip_text":"Billing_style_tooltip_text__37XI2"};